import type { Audience } from "../../audience/audience";

const AdminMenuItems: any[] = [
  {
    id: "1",
    url: "/",
    icon: "Home",
    labels: {
      es: {
        s: "Inicio",
        p: "M",
      },
      en: {
        s: "Home",
      },
      pt: {
        s: "Início",
        p: "M",
      },
    },
    permission: null,
  },
  {
    id: "2",
    url: "/musicalWork/list",
    icon: "MusicNote",
    labels: {
      es: {
        s: "Obras",
        p: "F",
      },
      en: {
        s: "Works",
      },
      pt: {
        s: "Obras",
        p: "F",
      },
    },
    permission: "musicalWork_retrieve",
  },
  {
    id: "3",
    url: "/authorComposer/list",
    icon: "Person",
    labels: {
      es: {
        s: "Autores/Compositores",
        p: "M",
      },
      en: {
        s: "Authors/Composers",
      },
      pt: {
        s: "Autores/Compositores",
        p: "M",
      },
    },
    permission: "authorComposer_retrieve",
  },
  {
    id: "4",
    url: "/publisher/list",
    icon: "MenuBook",
    labels: {
      es: {
        s: "Editoriales",
        p: "M",
      },
      en: {
        s: "Publishers",
      },
      pt: {
        s: "Editoras",
        p: "F",
      },
    },
    permission: "publisher_retrieve",
  },
  {
    id: "5",
    url: "/interpreter/list",
    icon: "Mic",
    labels: {
      es: {
        s: "Intérpretes",
        p: "M",
      },
      en: {
        s: "Interpreters",
      },
      pt: {
        s: "Intérpretes",
        p: "M",
      },
    },
    permission: "interpreter_retrieve",
  },
  {
    name: "editionsGroup",
    labels: {
      es: {
        s: "Ediciones",
        p: "Ediciones",
        g: "M",
      },
      en: {
        s: "Editions",
        p: "Editions",
      },
      pt: {
        s: "Edições",
        p: "Edições",
        g: "M",
      },
    },
    items: [
      {
        id: "6.1",
        url: "/edition/list",
        icon: "EditNote",
        labels: {
          es: {
            s: "En Preparación",
            p: "M",
          },
          en: {
            s: "In Preparation",
          },
          pt: {
            s: "Em Preparação",
            p: "M",
          },
        },
        permission: "edition_retrieve",
      },
      {
        id: "6.2",
        url: "/signedEdition/list",
        icon: "Draw",
        labels: {
          es: {
            s: "Firmadas",
          },
          en: {
            s: "Signed",
          },
          pt: {
            s: "Assinadas",
          },
        },
        permission: "signedEdition_retrieve",
      },
    ],
    id: "editionsGroup",
    icon: "CollectionsBookmark",
  },
  {
    name: "dataGroup",
    labels: {
      en: {
        s: "Auxiliary Data",
        p: "Auxiliary Data",
      },
      es: {
        s: "Datos Auxiliares",
        p: "Datos Auxiliares",
        g: "M",
      },
      pt: {
        s: "Dados Auxiliares",
        p: "Dados Auxiliares",
        g: "M",
      },
    },
    items: [
      {
        id: "7.1",
        url: "/contractObservation/list?type=GLOBAL",
        icon: "Description",
        labels: {
          es: {
            s: "Observaciones",
            p: "M",
          },
          en: {
            s: "Observations",
          },
          pt: {
            s: "Observações",
            p: "M",
          },
        },
        permission: "contractObservation_retrieve",
      },
      {
        id: "7.2",
        url: "/musicalGenre/list",
        icon: "Album",
        labels: {
          es: {
            s: "Géneros Musicales",
            p: "M",
          },
          en: {
            s: "Musical Genres",
          },
          pt: {
            s: "Gêneros Musicais",
            p: "M",
          },
        },
        permission: "musicalGenre_retrieve",
      },
      {
        id: "7.3",
        url: "/territory/list",
        icon: "TravelExplore",
        labels: {
          es: {
            s: "Territorios",
            p: "M",
          },
          en: {
            s: "Territories",
          },
          pt: {
            s: "Territórios",
            p: "M",
          },
        },
        permission: "territory_update",
      },
      {
        id: "7.4",
        url: "/platform/list",
        icon: "Storefront",
        labels: {
          es: {
            s: "Plataformas (Fonogramas)",
            p: "F",
          },
          en: {
            s: "Platforms (Phonograms)",
          },
          pt: {
            s: "Plataformas (Fonogramas)",
            p: "F",
          },
        },
        permission: "platform_retrieve",
      },
      {
        id: "7.5",
        url: "/platformLinkType/list",
        icon: "Link",
        labels: {
          es: {
            s: "Versión (Fonogramas)",
            p: "F",
          },
          en: {
            s: "Version (Phonograms)",
          },
          pt: {
            s: "Versão (Fonogramas)",
            p: "F",
          },
        },
        permission: "platformLinkType_retrieve",
      },
    ],
    id: "dataGroup",
    icon: "TableChart",
  },
  {
    name: "toolsGroup",
    labels: {
      es: {
        s: "Herramientas",
        p: "Herramientas",
        g: "F",
      },
      en: {
        s: "Tools",
        p: "Tools",
      },
      pt: {
        s: "Ferramentas",
        p: "Ferramentas",
        g: "F",
      },
    },
    items: [
      {
        id: "8.1",
        url: "/idas",
        icon: "ListAlt",
        labels: {
          es: {
            s: "IDAs",
            p: "F",
          },
          en: {
            s: "IDAs",
          },
          pt: {
            s: "IDAs",
            p: "F",
          },
        },
        permission: "country_retrieve",
        customPage: true,
        pageName: "idas",
      },
      {
        id: "8.2",
        url: "/onis",
        icon: "Search",
        labels: {
          es: {
            s: "ONIs",
            p: "F",
          },
          en: {
            s: "ONIs",
          },
          pt: {
            s: "ONIs",
            p: "F",
          },
        },
        permission: "country_retrieve",
        customPage: true,
        pageName: "onis",
      },
      {
        id: "8.3",
        url: "/cuesheets",
        icon: "Checklist",
        labels: {
          es: {
            s: "Cue Sheets",
            p: "M",
          },
          en: {
            s: "Cue Sheets",
          },
          pt: {
            s: "Cue Sheets",
            p: "M",
          },
        },
        permission: "country_retrieve",
        customPage: true,
        pageName: "cuesheets",
      },
    ],
    id: "toolsGroup",
    icon: "Build",
  },
  {
    name: "financeGroup",
    labels: {
      es: {
        s: "Finanzas",
        p: "Finanzas",
        g: "F",
      },
      en: {
        s: "Finance",
        p: "Finance",
      },
      pt: {
        s: "Finanças",
        p: "Finanças",
        g: "F",
      },
    },
    items: [
      {
        id: "9.1",
        url: "/creditAccount/list",
        icon: "Toll",
        labels: {
          es: {
            s: "Créditos Jupiter",
            p: "M",
          },
          en: {
            s: "Jupiter Credits",
          },
          pt: {
            s: "Créditos Jupiter",
            p: "M",
          },
        },
        permission: "creditAccount_retrieve",
      },
      {
        id: "9.2",
        url: "/creditPurchase/list",
        icon: "ShoppingCart",
        labels: {
          es: {
            s: "Compras de Créditos",
            p: "F",
          },
          en: {
            s: "Credit Purchases",
          },
          pt: {
            s: "Compras de Créditos",
            p: "F",
          },
        },
        permission: "creditPurchase_retrieve",
        roles: ["SysAdmin"],
      },
      {
        id: "9.3",
        url: "/my-credit-purchases/list",
        icon: "ShoppingCart",
        labels: {
          es: {
            s: "Compras de Créditos",
            p: "F",
          },
          en: {
            s: "Credit Purchases",
          },
          pt: {
            s: "Compras de Créditos",
            p: "F",
          },
        },
        permission: "creditPurchase_retrieve",
        roles: ["SiteAdmin"],
      },
      {
        id: "9.4",
        url: "/paymentReceipt/list?type=GLOBAL",
        icon: "Receipt",
        labels: {
          es: {
            s: "Comprobantes de Pago",
            p: "M",
          },
          en: {
            s: "Payment Receipts",
          },
          pt: {
            s: "Comprovantes de Pagamento",
            p: "M",
          },
        },
        permission: "paymentReceipt_update",
      },
    ],
    id: "financeGroup",
    icon: "Payments",
  },
  {
    name: "configGroup",
    labels: {
      es: {
        s: "Configuración",
        p: "Configuración",
        g: "F",
      },
      en: {
        s: "Configuration",
        p: "Configuration",
      },
      pt: {
        s: "Configurações",
        p: "Configurações",
        g: "F",
      },
    },
    items: [
      {
        id: "10.1",
        url: "/tenantProfile/list",
        icon: "Business",
        labels: {
          es: {
            s: "Datos del Cliente",
            p: "F",
          },
          en: {
            s: "Client Data",
          },
          pt: {
            s: "Dados do Cliente",
            p: "F",
          },
        },
        permission: "tenantProfile_retrieve",
        roles: ["SiteAdmin"],
      },
      {
        id: "10.2",
        url: "/site-user/list",
        icon: "PersonOutline",
        labels: {
          es: {
            s: "Usuarios",
            p: "M",
          },
          en: {
            s: "Users",
          },
          pt: {
            s: "Usuários",
            p: "M",
          },
        },
        permission: "user_retrieve",
        roles: ["SiteAdmin"],
      },
    ],
    id: "configGroup",
    icon: "Settings",
    bottom: true,
  },
  {
    id: "11",
    icon: "__divider__",
    labels: {
      es: {
        s: "Administración",
        p: "Administración",
        g: "F",
      },
      en: {
        s: "Administration",
        p: "Administration",
      },
      pt: {
        s: "Administração",
        p: "Administração",
        g: "F",
      },
    },
    permission: null,
    roles: ["SysAdmin"],
  },
  {
    name: "tenantsGroup",
    labels: {
      es: {
        s: "Clientes Júpiter",
        p: "Clientes Júpiter",
        g: "M",
      },
      en: {
        s: "Tenants",
        p: "Tenants",
      },
      pt: {
        s: "Clientes Júpiter",
        p: "Clientes Júpiter",
        g: "M",
      },
    },
    items: [
      {
        id: "12.1",
        url: "/tenant/list",
        icon: "Group",
        labels: {
          es: {
            s: "Clientes",
            p: "M",
          },
          en: {
            s: "Tenants",
          },
          pt: {
            s: "Clientes",
            p: "M",
          },
        },
        permission: "tenant_update",
      },
      {
        id: "12.2",
        url: "/tenantType/list",
        icon: "FolderShared",
        labels: {
          es: {
            s: "Tipos de Cliente",
            p: "M",
          },
          en: {
            s: "Tenant Types",
          },
          pt: {
            s: "Tipos de Cliente",
            p: "M",
          },
        },
        permission: "tenantType_update",
      },
      {
        id: "12.3",
        url: "/tenantStatus/list",
        icon: "SignalWifiStatusbarConnectedNoInternet4",
        labels: {
          es: {
            s: "Estados de Cliente",
            p: "M",
          },
          en: {
            s: "Tenant Statuses",
          },
          pt: {
            s: "Status dos Clientes",
            p: "M",
          },
        },
        permission: "tenantStatus_update",
      },
      {
        id: "12.4",
        url: "/enterpriseGroup/list",
        icon: "Domain",
        labels: {
          es: {
            s: "Grupos Empresariales",
            p: "M",
          },
          en: {
            s: "Enterprise Groups",
          },
          pt: {
            s: "Grupos Empresariais",
            p: "M",
          },
        },
        permission: "enterpriseGroup_update",
      },
      {
        id: "12.5",
        url: "/tenantPlan/list",
        icon: "Tune",
        labels: {
          es: {
            s: "Planes",
            p: "M",
          },
          en: {
            s: "Plans",
          },
          pt: {
            s: "Planos",
            p: "M",
          },
        },
        permission: "tenantPlan_update",
      },
      {
        id: "12.6",
        url: "/creditTier/list",
        icon: "Grade",
        labels: {
          es: {
            s: "Niveles de Créditos",
            p: "M",
          },
          en: {
            s: "Credit Tiers",
          },
          pt: {
            s: "Níveis de Créditos",
            p: "M",
          },
        },
        permission: "creditTier_update",
      },
    ],
    id: "tenantsGroup",
    icon: "Badge",
  },
  {
    name: "securityGroup",
    labels: {
      es: {
        s: "Seguridad",
        p: "Seguridad",
        g: "F",
      },
      en: {
        s: "Security",
        p: "Security",
      },
      pt: {
        s: "Segurança",
        p: "Segurança",
        g: "F",
      },
    },
    items: [
      {
        id: "13.1",
        url: "/user/list",
        icon: "PersonOutline",
        labels: {
          es: {
            s: "Usuarios",
            p: "M",
          },
          en: {
            s: "Users",
          },
          pt: {
            s: "Usuários",
            p: "M",
          },
        },
        permission: "user_create",
        roles: ["SysAdmin"],
      },
      {
        id: "13.2",
        url: "/role/list",
        icon: "EngineeringOutlined",
        labels: {
          es: {
            s: "Roles",
            p: "M",
          },
          en: {
            s: "Roles",
          },
          pt: {
            s: "Funções",
            p: "F",
          },
        },
        permission: "role_create",
      },
      {
        id: "13.3",
        url: "/permission/list",
        icon: "VpnKeyOutlined",
        labels: {
          es: {
            s: "Permisos",
            p: "M",
          },
          en: {
            s: "Permissions",
          },
          pt: {
            s: "Permissões",
            p: "F",
          },
        },
        permission: "permission_create",
      },
    ],
    id: "securityGroup",
    icon: "Security",
  },
  {
    name: "systemGroup",
    labels: {
      es: {
        s: "Sistema",
        p: "Sistema",
        g: "M",
      },
      en: {
        s: "System",
        p: "System",
      },
      pt: {
        s: "Sistema",
        p: "Sistema",
        g: "M",
      },
    },
    items: [
      {
        id: "14.1",
        url: "/esignatureConfig/list",
        icon: "Draw",
        labels: {
          es: {
            s: "Firma Electrónica",
            p: "F",
          },
          en: {
            s: "E-Signature Config",
          },
          pt: {
            s: "Assinatura Eletrônica",
            p: "F",
          },
        },
        permission: "esignatureConfig_retrieve",
      },
      {
        id: "14.2",
        url: "/tadManagerConfig/list",
        icon: "BadgeOutlined",
        labels: {
          es: {
            s: "Gestor TAD",
            p: "M",
          },
          en: {
            s: "TAD Manager",
          },
          pt: {
            s: "Gestor TAD",
            p: "M",
          },
        },
        permission: "tadManagerConfig_retrieve",
      },
      {
        id: "14.3",
        url: "/report/list",
        icon: "HistoryEdu",
        labels: {
          es: {
            s: "Reportes",
            p: "M",
          },
          en: {
            s: "Reports",
          },
          pt: {
            s: "Relatórios",
            p: "M",
          },
        },
        permission: "report_update",
      },
      {
        id: "14.4",
        url: "/editionType/list",
        icon: "Category",
        labels: {
          es: {
            s: "Tipos de Edición",
            p: "M",
          },
          en: {
            s: "Edition Types",
          },
          pt: {
            s: "Tipos de Edição",
            p: "M",
          },
        },
        permission: "editionType_update",
      },
      {
        id: "14.5",
        url: "/paymentReceiptType/list",
        icon: "Category",
        labels: {
          es: {
            s: "Tipos de Trámite de Ediciones",
            p: "M",
          },
          en: {
            s: "Edition Process Types",
          },
          pt: {
            s: "Tipos de Trâmite de Edições",
            p: "M",
          },
        },
        permission: "paymentReceiptType_update",
      },
      {
        id: "14.6",
        url: "/collectiveManagementSociety/list",
        icon: "Business",
        labels: {
          es: {
            s: "Sociedades de Gestión",
            p: "F",
          },
          en: {
            s: "Management Societies",
          },
          pt: {
            s: "Sociedades de Gestão",
            p: "F",
          },
        },
        permission: "collectiveManagementSociety_update",
      },
      {
        id: "14.7",
        url: "/currency/list",
        icon: "AttachMoney",
        labels: {
          es: {
            s: "Monedas",
            p: "F",
          },
          en: {
            s: "Currencies",
          },
          pt: {
            s: "Moedas",
            p: "F",
          },
        },
        permission: "currency_update",
      },
    ],
    id: "systemGroup",
    icon: "SettingsSuggest",
  },
  {
    name: "monitoringGroup",
    labels: {
      es: {
        s: "Monitoreo",
        p: "Monitoreo",
        g: "M",
      },
      en: {
        s: "Monitoring",
        p: "Monitoring",
      },
      pt: {
        s: "Monitoramento",
        p: "Monitoramento",
        g: "M",
      },
    },
    items: [
      {
        id: "15.1",
        url: "/satelliteMachine/list",
        icon: "Dns",
        labels: {
          es: {
            s: "Máquinas Satélite",
            p: "F",
          },
          en: {
            s: "Satellite Machines",
          },
          pt: {
            s: "Máquinas Satélite",
            p: "F",
          },
        },
        permission: "satelliteMachine_retrieve",
      },
      {
        id: "15.2",
        url: "/satelliteTask/list",
        icon: "Assignment",
        labels: {
          es: {
            s: "Tareas de Satélite",
            p: "F",
          },
          en: {
            s: "Satellite Tasks",
          },
          pt: {
            s: "Tarefas de Satélite",
            p: "F",
          },
        },
        permission: "satelliteTask_retrieve",
      },
      {
        id: "15.3",
        url: "/satelliteHeartbeat/list",
        icon: "MonitorHeart",
        labels: {
          es: {
            s: "Heartbeats",
            p: "M",
          },
          en: {
            s: "Heartbeats",
          },
          pt: {
            s: "Heartbeats",
            p: "M",
          },
        },
        permission: "satelliteHeartbeat_retrieve",
      },
      {
        id: "15.4",
        url: "/workerEvent/list",
        icon: "Event",
        labels: {
          es: {
            s: "Eventos de Workers",
            p: "M",
          },
          en: {
            s: "Worker Events",
          },
          pt: {
            s: "Eventos de Workers",
            p: "M",
          },
        },
        permission: "workerEvent_retrieve",
      },
      {
        id: "15.5",
        url: "/botRun/list",
        icon: "PrecisionManufacturing",
        labels: {
          es: {
            s: "Monitor de Bots",
            p: "M",
          },
          en: {
            s: "Bots Monitor",
          },
          pt: {
            s: "Monitor de Bots",
            p: "M",
          },
        },
        permission: "botRun_retrieve",
      },
      {
        id: "15.6",
        url: "/automation",
        icon: "Insights",
        labels: {
          es: {
            s: "Monitor de Automatización",
            p: "M",
          },
          en: {
            s: "Automation Monitor",
          },
          pt: {
            s: "Monitor de Automação",
            p: "M",
          },
        },
        permission: "botRun_retrieve",
        roles: ["SysAdmin"],
        customPage: true,
        pageName: "automation",
      },
      {
        id: "15.7",
        url: "/simulation",
        icon: "Science",
        labels: {
          es: {
            s: "Simulación",
            p: "F",
          },
          en: {
            s: "Simulation",
          },
          pt: {
            s: "Simulação",
            p: "F",
          },
        },
        permission: "simulation_run",
        roles: ["SysAdmin"],
        customPage: true,
        pageName: "simulation",
      },
    ],
    id: "monitoringGroup",
    icon: "Monitor",
  },
  {
    name: "dashboardAdminGroup",
    labels: {
      es: {
        s: "Dashboards",
        p: "Dashboards",
        g: "M",
      },
      en: {
        s: "Dashboards",
        p: "Dashboards",
      },
      pt: {
        s: "Dashboards",
        p: "Dashboards",
        g: "M",
      },
    },
    items: [
      {
        id: "16.1",
        url: "/dashboardWidget/list",
        icon: "Widgets",
        labels: {
          es: {
            s: "Catálogo Widgets",
            p: "M",
          },
          en: {
            s: "Widget Catalog",
          },
          pt: {
            s: "Catálogo Widgets",
            p: "M",
          },
        },
        permission: "dashboardWidget_retrieve",
      },
      {
        id: "16.2",
        url: "/tenantWidgetAccess/list",
        icon: "VpnKey",
        labels: {
          es: {
            s: "Acceso por Tenant",
            p: "M",
          },
          en: {
            s: "Tenant Access",
          },
          pt: {
            s: "Acesso por Tenant",
            p: "M",
          },
        },
        permission: "tenantWidgetAccess_retrieve",
      },
      {
        id: "16.3",
        url: "/dashboardLayoutTemplate/list",
        icon: "ViewQuilt",
        labels: {
          es: {
            s: "Templates Layout",
            p: "M",
          },
          en: {
            s: "Layout Templates",
          },
          pt: {
            s: "Templates Layout",
            p: "M",
          },
        },
        permission: "dashboardLayoutTemplate_retrieve",
      },
      {
        id: "16.4",
        url: "/userWidgetConfig/list",
        icon: "AccountTree",
        labels: {
          es: {
            s: "Widgets de Usuarios",
            p: "M",
          },
          en: {
            s: "User Widgets",
          },
          pt: {
            s: "Widgets de Usuários",
            p: "M",
          },
        },
        permission: "userWidgetConfig_retrieve",
      },
    ],
    id: "dashboardAdminGroup",
    icon: "Dashboard",
  },
  /* TEMPORAL: grupo 'Asistente IA' oculto del menú hasta que la IA funcione bien.
     Descomentar para reactivar (junto con el botón iO en PageLayout).
  {
    name: "aiAssistantGroup",
    labels: {
      es: {
        s: "Asistente IA",
        p: "Asistente IA",
        g: "M",
      },
      en: {
        s: "AI Assistant",
        p: "AI Assistant",
      },
      pt: {
        s: "Assistente IA",
        p: "Assistente IA",
        g: "M",
      },
    },
    items: [
      {
        id: "17.1",
        url: "/tenantLlmConfig/list",
        icon: "SmartToy",
        labels: {
          es: {
            s: "Configuraciones LLM",
            p: "F",
          },
          en: {
            s: "LLM Configurations",
          },
          pt: {
            s: "Configurações LLM",
            p: "F",
          },
        },
        permission: "tenantLlmConfig_update",
      },
      {
        id: "17.2",
        url: "/tenantDocument/list",
        icon: "Article",
        labels: {
          es: {
            s: "Documentos LLM",
            p: "M",
          },
          en: {
            s: "LLM Documents",
          },
          pt: {
            s: "Documentos LLM",
            p: "M",
          },
        },
        permission: "tenantDocument_update",
      },
      {
        id: "17.3",
        url: "/tenantTokenUsage/list",
        icon: "Token",
        labels: {
          es: {
            s: "Uso de Tokens",
            p: "Uso de Tokens",
            g: "M",
          },
          en: {
            s: "Token Usage",
            p: "Token Usage",
          },
          pt: {
            s: "Uso de Tokens",
            p: "Uso de Tokens",
            g: "M",
          },
        },
        permission: "tenantTokenUsage_retrieve",
      },
      {
        id: "17.4",
        url: "/tenantStorageUsage/list",
        icon: "Storage",
        labels: {
          es: {
            s: "Uso de Almacenamiento",
            p: "Uso de Almacenamiento",
            g: "M",
          },
          en: {
            s: "Storage Usage",
            p: "Storage Usage",
          },
          pt: {
            s: "Uso de Armazenamento",
            p: "Uso de Armazenamento",
            g: "M",
          },
        },
        permission: "tenantStorageUsage_retrieve",
      },
      {
        id: "17.5",
        url: "/llmProvider/list",
        icon: "Psychology",
        labels: {
          es: {
            s: "Proveedores LLM",
            p: "M",
          },
          en: {
            s: "LLM Providers",
          },
          pt: {
            s: "Provedores LLM",
            p: "M",
          },
        },
        permission: "llmProvider_update",
      },
      {
        id: "17.6",
        url: "/aiSearchConversation/list",
        icon: "Chat",
        labels: {
          es: {
            s: "Conversaciones",
            p: "F",
          },
          en: {
            s: "Conversations",
          },
          pt: {
            s: "Conversas",
            p: "F",
          },
        },
        permission: "aiSearchConversation_retrieve",
        roles: ["SysAdmin"],
      },
      {
        id: "17.7",
        url: "/aiSearchPattern/list",
        icon: "Pattern",
        labels: {
          es: {
            s: "Patrones AI Search",
            p: "M",
          },
          en: {
            s: "AI Search Patterns",
          },
          pt: {
            s: "Padrões AI Search",
            p: "M",
          },
        },
        permission: "aiSearchPattern_retrieve",
      },
      {
        id: "17.8",
        url: "/aiSearchExperiment/list",
        icon: "Science",
        labels: {
          es: {
            s: "Experimentos A/B",
            p: "M",
          },
          en: {
            s: "A/B Experiments",
          },
          pt: {
            s: "Experimentos A/B",
            p: "M",
          },
        },
        permission: "aiSearchExperiment_retrieve",
      },
      {
        id: "17.9",
        url: "/aiSearchResponse/list",
        icon: "QuestionAnswer",
        labels: {
          es: {
            s: "Respuestas AI",
            p: "F",
          },
          en: {
            s: "AI Responses",
          },
          pt: {
            s: "Respostas AI",
            p: "F",
          },
        },
        permission: "aiSearchResponse_retrieve",
      },
    ],
    id: "aiAssistantGroup",
    icon: "SmartToy",
  },
  */
];

const MainMenuItems: any[] = [
  {
    id: "1",
    url: "/",
    icon: "Home",
    labels: {
      es: {
        s: "Inicio",
        p: "M",
      },
      en: {
        s: "Home",
      },
      pt: {
        s: "Início",
        p: "M",
      },
    },
    permission: null,
  },
  {
    id: "2",
    url: "/musicalWork/list",
    icon: "MusicNote",
    labels: {
      es: {
        s: "Obras",
        p: "F",
      },
      en: {
        s: "Works",
      },
      pt: {
        s: "Obras",
        p: "F",
      },
    },
    permission: "musicalWork_retrieve",
  },
  {
    id: "3",
    url: "/authorComposer/list",
    icon: "Person",
    labels: {
      es: {
        s: "Autores/Compositores",
        p: "M",
      },
      en: {
        s: "Authors/Composers",
      },
      pt: {
        s: "Autores/Compositores",
        p: "M",
      },
    },
    permission: "authorComposer_retrieve",
  },
  {
    id: "4",
    url: "/publisher/list",
    icon: "MenuBook",
    labels: {
      es: {
        s: "Editoriales",
        p: "M",
      },
      en: {
        s: "Publishers",
      },
      pt: {
        s: "Editoras",
        p: "F",
      },
    },
    permission: "publisher_retrieve",
  },
  {
    id: "5",
    url: "/interpreter/list",
    icon: "Mic",
    labels: {
      es: {
        s: "Intérpretes",
        p: "M",
      },
      en: {
        s: "Interpreters",
      },
      pt: {
        s: "Intérpretes",
        p: "M",
      },
    },
    permission: "interpreter_retrieve",
  },
  {
    name: "editionsGroup",
    labels: {
      es: {
        s: "Ediciones",
        p: "Ediciones",
        g: "M",
      },
      en: {
        s: "Editions",
        p: "Editions",
      },
      pt: {
        s: "Edições",
        p: "Edições",
        g: "M",
      },
    },
    items: [
      {
        id: "6.1",
        url: "/edition/list",
        icon: "EditNote",
        labels: {
          es: {
            s: "En Preparación",
            p: "M",
          },
          en: {
            s: "In Preparation",
          },
          pt: {
            s: "Em Preparação",
            p: "M",
          },
        },
        permission: "edition_retrieve",
      },
      {
        id: "6.2",
        url: "/signedEdition/list",
        icon: "Draw",
        labels: {
          es: {
            s: "Firmadas",
          },
          en: {
            s: "Signed",
          },
          pt: {
            s: "Assinadas",
          },
        },
        permission: "signedEdition_retrieve",
      },
    ],
    id: "editionsGroup",
    icon: "CollectionsBookmark",
  },
  {
    name: "dataGroup",
    labels: {
      en: {
        s: "Auxiliary Data",
        p: "Auxiliary Data",
      },
      es: {
        s: "Datos Auxiliares",
        p: "Datos Auxiliares",
        g: "M",
      },
      pt: {
        s: "Dados Auxiliares",
        p: "Dados Auxiliares",
        g: "M",
      },
    },
    items: [
      {
        id: "7.1",
        url: "/contractObservation/list?type=GLOBAL",
        icon: "Description",
        labels: {
          es: {
            s: "Observaciones",
            p: "M",
          },
          en: {
            s: "Observations",
          },
          pt: {
            s: "Observações",
            p: "M",
          },
        },
        permission: "contractObservation_retrieve",
      },
      {
        id: "7.2",
        url: "/musicalGenre/list",
        icon: "Album",
        labels: {
          es: {
            s: "Géneros Musicales",
            p: "M",
          },
          en: {
            s: "Musical Genres",
          },
          pt: {
            s: "Gêneros Musicais",
            p: "M",
          },
        },
        permission: "musicalGenre_retrieve",
      },
      {
        id: "7.3",
        url: "/territory/list",
        icon: "TravelExplore",
        labels: {
          es: {
            s: "Territorios",
            p: "M",
          },
          en: {
            s: "Territories",
          },
          pt: {
            s: "Territórios",
            p: "M",
          },
        },
        permission: "territory_update",
      },
      {
        id: "7.4",
        url: "/platform/list",
        icon: "Storefront",
        labels: {
          es: {
            s: "Plataformas (Fonogramas)",
            p: "F",
          },
          en: {
            s: "Platforms (Phonograms)",
          },
          pt: {
            s: "Plataformas (Fonogramas)",
            p: "F",
          },
        },
        permission: "platform_retrieve",
      },
      {
        id: "7.5",
        url: "/platformLinkType/list",
        icon: "Link",
        labels: {
          es: {
            s: "Versión (Fonogramas)",
            p: "F",
          },
          en: {
            s: "Version (Phonograms)",
          },
          pt: {
            s: "Versão (Fonogramas)",
            p: "F",
          },
        },
        permission: "platformLinkType_retrieve",
      },
    ],
    id: "dataGroup",
    icon: "TableChart",
  },
  {
    name: "toolsGroup",
    labels: {
      es: {
        s: "Herramientas",
        p: "Herramientas",
        g: "F",
      },
      en: {
        s: "Tools",
        p: "Tools",
      },
      pt: {
        s: "Ferramentas",
        p: "Ferramentas",
        g: "F",
      },
    },
    items: [
      {
        id: "8.1",
        url: "/idas",
        icon: "ListAlt",
        labels: {
          es: {
            s: "IDAs",
            p: "F",
          },
          en: {
            s: "IDAs",
          },
          pt: {
            s: "IDAs",
            p: "F",
          },
        },
        permission: "country_retrieve",
        customPage: true,
        pageName: "idas",
      },
      {
        id: "8.2",
        url: "/onis",
        icon: "Search",
        labels: {
          es: {
            s: "ONIs",
            p: "F",
          },
          en: {
            s: "ONIs",
          },
          pt: {
            s: "ONIs",
            p: "F",
          },
        },
        permission: "country_retrieve",
        customPage: true,
        pageName: "onis",
      },
      {
        id: "8.3",
        url: "/cuesheets",
        icon: "Checklist",
        labels: {
          es: {
            s: "Cue Sheets",
            p: "M",
          },
          en: {
            s: "Cue Sheets",
          },
          pt: {
            s: "Cue Sheets",
            p: "M",
          },
        },
        permission: "country_retrieve",
        customPage: true,
        pageName: "cuesheets",
      },
    ],
    id: "toolsGroup",
    icon: "Build",
  },
  {
    name: "financeGroup",
    labels: {
      es: {
        s: "Finanzas",
        p: "Finanzas",
        g: "F",
      },
      en: {
        s: "Finance",
        p: "Finance",
      },
      pt: {
        s: "Finanças",
        p: "Finanças",
        g: "F",
      },
    },
    items: [
      {
        id: "9.1",
        url: "/creditAccount/list",
        icon: "Toll",
        labels: {
          es: {
            s: "Créditos Jupiter",
            p: "M",
          },
          en: {
            s: "Jupiter Credits",
          },
          pt: {
            s: "Créditos Jupiter",
            p: "M",
          },
        },
        permission: "creditAccount_retrieve",
      },
      {
        id: "9.2",
        url: "/creditPurchase/list",
        icon: "ShoppingCart",
        labels: {
          es: {
            s: "Compras de Créditos",
            p: "F",
          },
          en: {
            s: "Credit Purchases",
          },
          pt: {
            s: "Compras de Créditos",
            p: "F",
          },
        },
        permission: "creditPurchase_retrieve",
        roles: ["SysAdmin"],
      },
      {
        id: "9.3",
        url: "/my-credit-purchases/list",
        icon: "ShoppingCart",
        labels: {
          es: {
            s: "Compras de Créditos",
            p: "F",
          },
          en: {
            s: "Credit Purchases",
          },
          pt: {
            s: "Compras de Créditos",
            p: "F",
          },
        },
        permission: "creditPurchase_retrieve",
        roles: ["SiteAdmin"],
      },
      {
        id: "9.4",
        url: "/paymentReceipt/list?type=GLOBAL",
        icon: "Receipt",
        labels: {
          es: {
            s: "Comprobantes de Pago",
            p: "M",
          },
          en: {
            s: "Payment Receipts",
          },
          pt: {
            s: "Comprovantes de Pagamento",
            p: "M",
          },
        },
        permission: "paymentReceipt_update",
      },
    ],
    id: "financeGroup",
    icon: "Payments",
  },
  {
    name: "configGroup",
    labels: {
      es: {
        s: "Configuración",
        p: "Configuración",
        g: "F",
      },
      en: {
        s: "Configuration",
        p: "Configuration",
      },
      pt: {
        s: "Configurações",
        p: "Configurações",
        g: "F",
      },
    },
    items: [
      {
        id: "10.1",
        url: "/tenantProfile/list",
        icon: "Business",
        labels: {
          es: {
            s: "Datos del Cliente",
            p: "F",
          },
          en: {
            s: "Client Data",
          },
          pt: {
            s: "Dados do Cliente",
            p: "F",
          },
        },
        permission: "tenantProfile_retrieve",
        roles: ["SiteAdmin"],
      },
      {
        id: "10.2",
        url: "/site-user/list",
        icon: "PersonOutline",
        labels: {
          es: {
            s: "Usuarios",
            p: "M",
          },
          en: {
            s: "Users",
          },
          pt: {
            s: "Usuários",
            p: "M",
          },
        },
        permission: "user_retrieve",
        roles: ["SiteAdmin"],
      },
    ],
    id: "configGroup",
    icon: "Settings",
    bottom: true,
  },
  {
    name: "aiAssistantGroup",
    labels: {
      es: {
        s: "Asistente IA",
        p: "Asistente IA",
        g: "M",
      },
      en: {
        s: "AI Assistant",
        p: "AI Assistant",
      },
      pt: {
        s: "Assistente IA",
        p: "Assistente IA",
        g: "M",
      },
    },
    items: [
      {
        id: "11.1",
        url: "/tenantLlmConfig/list",
        icon: "SmartToy",
        labels: {
          es: {
            s: "Configuraciones LLM",
            p: "F",
          },
          en: {
            s: "LLM Configurations",
          },
          pt: {
            s: "Configurações LLM",
            p: "F",
          },
        },
        permission: "tenantLlmConfig_update",
      },
      {
        id: "11.2",
        url: "/tenantDocument/list",
        icon: "Article",
        labels: {
          es: {
            s: "Documentos LLM",
            p: "M",
          },
          en: {
            s: "LLM Documents",
          },
          pt: {
            s: "Documentos LLM",
            p: "M",
          },
        },
        permission: "tenantDocument_update",
      },
      {
        id: "11.3",
        url: "/tenantTokenUsage/list",
        icon: "Token",
        labels: {
          es: {
            s: "Uso de Tokens",
            p: "Uso de Tokens",
            g: "M",
          },
          en: {
            s: "Token Usage",
            p: "Token Usage",
          },
          pt: {
            s: "Uso de Tokens",
            p: "Uso de Tokens",
            g: "M",
          },
        },
        permission: "tenantTokenUsage_retrieve",
      },
      {
        id: "11.4",
        url: "/tenantStorageUsage/list",
        icon: "Storage",
        labels: {
          es: {
            s: "Uso de Almacenamiento",
            p: "Uso de Almacenamiento",
            g: "M",
          },
          en: {
            s: "Storage Usage",
            p: "Storage Usage",
          },
          pt: {
            s: "Uso de Armazenamento",
            p: "Uso de Armazenamento",
            g: "M",
          },
        },
        permission: "tenantStorageUsage_retrieve",
      },
    ],
    id: "aiAssistantGroup",
    icon: "SmartToy",
  },
];

const AuthorMenuItems: any[] = [
  {
    id: "1",
    url: "/",
    icon: "Home",
    labels: {
      es: {
        s: "Inicio",
        p: "M",
      },
      en: {
        s: "Home",
      },
      pt: {
        s: "Início",
        p: "M",
      },
    },
    permission: null,
  },
];

export const menuItems = MainMenuItems;

// El menú de cada audiencia declarada en hkconfig.json (audiences.<a>.menu).
// Una audiencia que el config no declara no ve ninguno.
export const menusByAudience: Partial<Record<Audience, any[]>> = {
  platform: AdminMenuItems,
  publisher: MainMenuItems,
  author: AuthorMenuItems,
};
